import { CircularProgress } from '@mui/material'
import { useEffect, useState } from 'react'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import InvoiceListing from 'src/supportPortal/views/payoutReports/InvoiceListing'
import { getMinimalMentorData } from 'src/supportPortal/views/therapists/util'

export default function PractitionerPayoutReceipts({ fetchSingleMentorSignature, mentorSlug }) {
  const [practitioner, setPractitioner] = useState(null)
  const [loading, setLoading] = useState(true)

  async function getSelectedPractitioner() {
    const resp = await getMinimalMentorData(mentorSlug, true, fetchSingleMentorSignature)
    setPractitioner(resp)
  }

  async function setup() {
    setLoading(true)
    await getSelectedPractitioner()
    setLoading(false)
  }

  useEffect(() => {
    setup()
  }, [])
  return (
    <>
      <SupportHeader heading={`${practitioner?.firstName} Payout Receipts`} />
      {practitioner && !loading ? (
        <InvoiceListing
          targetEntityType="mentor"
          hideTargetEntityIdFilter
          // hideEntityName
          entityListOverride={[practitioner]}
          // hideMentorProfilePic
          initialFilters={{
            targetEntityTypes: 'mentor ',
            targetEntityIds: practitioner?.id,
          }}
        />
      ) : (
        <div className="d-flex justify-content-center align-items-center h-100 w-100">
          <CircularProgress />
        </div>
      )}
    </>
  )
}
